"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6566],{

/***/ 76566:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_responsive_modal__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(31190);
/* harmony import */ var react_youtube__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5406);




var opts = {
    height: "390",
    width: "640",
    playerVars: {
        autoplay: 1,
        rel: 0
    }
};
var VideoModal = function(param) {
    var open = param.open, onCloseModal = param.onCloseModal;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_responsive_modal__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        classNames: {
            modal: "video-modal",
            closeButton: "close-btn"
        },
        open: open,
        onClose: function() {
            return onCloseModal();
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "inner",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_youtube__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                videoId: "kmCc2zfZVzU",
                opts: opts
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (VideoModal);


/***/ })

}]);